import { Chart } from "primereact/chart";
import { useEffect, useState } from "react";
import WorkloadViewLarge from "./viewLarge/workloadViewLarge";
import ReactModal from "react-modal";
import { IWorkloadDetails } from "../../../../models/faculty/facultyWorkload";
import { connect, useDispatch } from "react-redux";
import { getWorkload } from "../../../../action/faculty/facultyWorkloadActionCreator";
import { setWorkload } from "../../../../store/slices/faculty/facultyWorkloadSlice";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

const WorkLoad = (props: IWorkloadDetails) => {
  const { workload, getFacultyWorkload, events, tasks } = props;
  const [chartData, setChartData] = useState({});
  const [showLarge, setShowLarge] = useState<boolean>(false);
  const dispatch = useDispatch();
  const handleShow = () => setShowLarge(true);
  const handleClose = () => setShowLarge(false);

  const Open = "#f2b53a";
  const InProgress = "#da7a1e";
  const OnHold = "#ff6501";
  const Completed = "#cc5200";
  const Due = "#956813";
  const Events = "#7c4a0f";

  const workloadColors = [Open, InProgress, OnHold, Completed, Due, Events];

  useEffect(() => {
    getFacultyWorkload();
  }, [tasks]);

  useEffect(() => {
    return () => {
      dispatch(setWorkload([]));
    };
  }, []);

  useEffect(() => {
    if (workload || events) {
      const today = moment().format("YYYY-MM-DD");
      const todayEvents = events.filter(
        (event) => moment(event.start.dateTime).format("YYYY-MM-DD") === today
      );
      const calendarEventsCount =
        todayEvents.length < 1 ? null : todayEvents.length;

      setChartData({
        labels: [
          "Open",
          "In Progress",
          "On Hold",
          "Completed",
          "Due",
          "Events",
        ],
        datasets: [
          {
            data: [
              workload?.open || null,
              workload?.inProgress || null,
              workload?.onHold || null,
              workload?.completed || null,
              workload?.due || null,
              calendarEventsCount,
            ],
            backgroundColor: workloadColors,
          },
        ],
      });
    }
  }, [workload, events]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
      },
      datalabels: {
        align: "center",
        color: "white",
        font: {
          weight: "bold",
          size: 14,
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return tooltipItem.label;
          },
          title: function () {
            return "";
          },
        },
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        displayColors: false,
        position: "average",
        caretPadding: 20,
        yAlign: "bottom",
      },
    },
    elements: {
      arc: {
        borderWidth: 0.6,
        borderColor: "white",
        borderRadius: 3,
      },
    },
  };

  return (
    <>
      <div className="card-wrap">
        {workload && (
          <>
            <div className="title">
              <h2>Workload</h2>
              <a
                className="btn-link"
                data-bs-toggle="modal"
                data-bs-target="#workload"
                title="Click to view large"
                onClick={handleShow}
              >
                Zoom In
              </a>
            </div>
            <div className="gardedistribution card p-1">
              <div id="chart-container">
                <Chart
                  type="doughnut"
                  data={chartData}
                  options={options}
                  className=""
                  width="350"
                  height="250"
                  plugins={[ChartDataLabels]}
                />
              </div>
              <div className="legend Workload-legend" id="legend-container">
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: Open }}
                  ></div>
                  <span>Open</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: InProgress }}
                  ></div>
                  <span>In progress</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: OnHold }}
                  ></div>
                  <span>On Hold</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: Completed }}
                  ></div>
                  <span>Completed</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: Due }}
                  ></div>
                  <span>Due</span>
                </div>
                <div className="legend-item">
                  <div
                    className="legend-color"
                    style={{ backgroundColor: Events }}
                  ></div>
                  <span>Events</span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <ReactModal
        isOpen={showLarge}
        onRequestClose={handleClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        style={{
          content: {
            width: "550px",
            outline: "none",
          },
        }}
      >
        <WorkloadViewLarge
          setShowWorkload={handleClose}
          workload={workload}
          events={events}
        />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getFacultyWorkload: () => getWorkload(),
};

function mapStateToProps(state: any) {
  return {
    tasks: state.task?.tasks,
    workload: state.workload.workload,
    events: state.calendar.calenderEvents || [],
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkLoad);
